import { render } from "./MaterialCard.vue?vue&type=template&id=612f38e8&scoped=true"
import script from "./MaterialCard.vue?vue&type=script&lang=js"
export * from "./MaterialCard.vue?vue&type=script&lang=js"

import "./MaterialCard.vue?vue&type=style&index=0&id=612f38e8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612f38e8"]])

export default __exports__